let callbackId = Date.now();

export function generateCallbackId() {
	return (callbackId++).toString();
}
